<script setup lang="ts">
import { cn } from "@/lib/utils";
import { TimeFieldInput as RekaTimeFieldInput } from "reka-ui";
import { type HTMLAttributes, inject, type Ref } from "vue";
import type { SegmentPart } from "reka-ui";

type Segment = { part: SegmentPart; value: string };

const props = defineProps<{ class?: HTMLAttributes["class"] }>();

const segments = inject<Ref<Segment[]>>("timeFieldSegments");
</script>

<template>
  <div
    :class="
      cn(
        'flex h-9 w-full min-w-[120px] items-center rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-within:ring-1 focus-within:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        props.class
      )
    "
  >
    <template v-for="item in segments" :key="item.part">
      <div v-if="item.part === 'literal'" class="px-0.5 text-muted-foreground">
        {{ item.value }}
      </div>
      <RekaTimeFieldInput
        v-else
        :part="item.part"
        class="rounded-sm px-0.5 focus:bg-accent focus:text-accent-foreground focus:outline-none"
      >
        {{ item.value }}
      </RekaTimeFieldInput>
    </template>
  </div>
</template>
